import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ConfirmDialog } from "./confirm-dialog";
import { useMyAccounts, useSwitchAccount } from "@/hooks/use-accounts";
import { useDeleteDemoAccount } from "@/hooks/use-demo-account";

export function DemoBanner() {
  const { data } = useMyAccounts();
  const switchAccount = useSwitchAccount();
  const deleteDemo = useDeleteDemoAccount();
  const [deleteOpen, setDeleteOpen] = useState(false);

  const accounts = data?.accounts ?? [];
  const activeAccountId = data?.active_account_id;
  const activeAccount = accounts.find((a) => a.id === activeAccountId);

  if (!activeAccount?.is_demo) return null;

  const firstNonDemo = accounts.find((a) => !a.is_demo);

  return (
    <div className="flex items-center gap-3 border-b border-[color:var(--color-warning)]/30 bg-[color:var(--color-warning)]/8 px-4 py-2">
      <FlaskConical className="size-4 shrink-0 text-[color:var(--color-warning)]" />
      <p className="flex-1 typo-body text-[color:var(--color-text-hi)]">
        You're exploring demo data
      </p>
      {firstNonDemo && (
        <Button
          variant="outline"
          size="sm"
          className="h-7 border-[color:var(--color-warning)]/40 text-[color:var(--color-text-hi)]"
          onClick={() => switchAccount.mutate(firstNonDemo.id)}
          disabled={switchAccount.isPending}
        >
          Switch back
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        className="h-7 border-[color:var(--color-danger)]/40 text-[color:var(--color-danger)]"
        onClick={() => setDeleteOpen(true)}
      >
        Delete demo account
      </Button>

      <ConfirmDialog
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        title="Delete demo account"
        description="This will permanently delete the demo account and all its data. Your production account is unaffected."
        confirmLabel="Delete demo account"
        variant="destructive"
        pending={deleteDemo.isPending}
        onConfirm={() => {
          deleteDemo.mutate(activeAccount.id, {
            onSuccess: () => setDeleteOpen(false),
          });
        }}
      />
    </div>
  );
}
